import { useState, useEffect } from "react";

export default function ImageSlider({ images }) {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 2500);

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div className="flex justify-center items-center">
      <div className="relative w-full max-w-xl overflow-hidden">

        <div
          className="flex transition-transform duration-700 ease-in-out"
          style={{
            transform: `translateX(-${current * 100}%)`
          }}
        >
          {images.map((img, index) => (
            <img
              key={index}
              src={`/images/why-us/${img}`}
              className="w-full flex-shrink-0 object-contain select-none pointer-events-none"
              alt=""
            />
          ))}
        </div>

      </div>
    </div>
  );
}